import React from 'react';
import PropTypes from 'prop-types';

export const ListingWrapper = (props) => {
  const { children } = props;
  return (
    <div className="ListingWrapper">
      { children[0] }
      {
        children[1] ?
          <div className="container-fluid thumb-addon">
            <div className="row">
              <div className="col-xs-12">
                { children[1] }
              </div>
            </div>
          </div> : null
      }
    </div>
  );
};

ListingWrapper.propTypes = {
  children: PropTypes.array
};
